import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Guid } from 'guid-typescript';
import { Observable, Subject as RxSubjtect, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ExamAssignStudents, ExamClasses, ExamCourses } from '../Exam/exam-assign/exam-assign.model';
import { Exam } from '../Exam/exam/exam.model';
import { ReportQuestionsAnswersCountFilter } from '../Exam/exams/exams.model';
import { Filters } from '../Groups/groups.model';
import { Profile, Report, ReportFilter } from '../Reports/reports.model';
import { TeacherRelation } from './../Evaluations/evaluations.model';
import { AcademicYear, AcademicYearGrade, Class, ClassesSubSubjects, ClassSubSubject, Constant, Course, Curriculum, Grade, GradeSubject, MainCurriculum, MainSubject, PagedGradeStudent, PagedParent, PagedResult, PagedStaff, PagedStudent, Parent, ProfileType, RoleGroupNode, Semester, Service, Staff, Student, SubGrade, Subject, SubjectPrerequisite, Subscription, SubscriptionService, SubSubject, SubSubjectSection } from './setup.model';
import { UserRole } from '../RolePermission/rolepermission.model';

@Injectable({
  providedIn: 'root'
})
export class SetupsService {
  private servicesSetupChangedSubject = new RxSubjtect<void>();
  servicesSetupChanged$ = this.servicesSetupChangedSubject.asObservable();

  constructor(public http: HttpClient) { }

  notifyServicesSetupChanged(): void {
    this.servicesSetupChangedSubject.next();
  }

  getConstant(): Observable<Constant[]> {
    return this.http.get<Constant[]>(`${environment.apiUrl}/Constant`);//.pipe(catchError(this.handelError));
  }

  getConstantGroup(mId: string, langId: string): Observable<Constant[]> {
    return this.http.get<Constant[]>(`${environment.apiUrl}/Constant/GetGroup/${mId}?langId=${langId}`);//.pipe(catchError(this.handelError));
  }

  getConstantsMainGroups(mId: string, langId: string): Observable<Constant[]> {
    return this.http.get<Constant[]>(`${environment.apiUrl}/Constant/GetConstantsMainGroups/${mId}?langId=${langId}`);//.pipe(catchError(this.handelError));
  }

  getConstantById(id: string): Observable<Constant>//Observable<constant[]>
  {
    return this.http.get<Constant>(`${environment.apiUrl}/Constant/${id}`).pipe(catchError(this.handelError));
  }

  updateConstant(Evaluation: Constant): Observable<Constant> {
    return this.http.put<Constant>(`${environment.apiUrl}/Constant/${Evaluation.id}`, Evaluation, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    });
  }

  addConstant(newRecord: Constant) {
    return this.http.post<Constant>(`${environment.apiUrl}/Constant`, newRecord, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }).pipe(catchError(this.handelError));
  }

  deletConstant(Evaluation: Constant) {
    return this.http.delete<Constant>(`${environment.apiUrl}/Constant/${Evaluation.id}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }).pipe(catchError(this.handelError));
  }

  getLanguageConstants(mId: string): Observable<Constant[]> {
    return this.http.get<Constant[]>(`${environment.apiUrl}/Constant/GetLanguageConstants/${mId}`);
  }

  getSubGradesByGradeId(gradeId: Guid): Observable<SubGrade[]> {
    return this.http.get<SubGrade[]>(`${environment.apiUrl}/Grade/GetSubGradesByGradeId/${gradeId}`);
  }

  getSubjectsByUserIdAndSubGradeId(subGradeId: Guid): Observable<Subject[]> {
    return this.http.get<Subject[]>(`${environment.apiUrl}/Subject/GetSubjectsByUserIdAndSubGradeId/${subGradeId}`);
  }

  getSubSubjectsByUserIdAndSubGradeId(subGradeId: Guid): Observable<Subject[]> {
    return this.http.get<Subject[]>(`${environment.apiUrl}/Subject/GetSubSubjectsByUserIdAndSubGradeId/${subGradeId}`);
  }

  getSubSubjectsByUserIdAndGradeId(gradeId: Guid): Observable<SubSubject[]> {
    return this.http.get<SubSubject[]>(`${environment.apiUrl}/Subject/GetSubSubjectsByUserIdAndGradeId/${gradeId}`);
  }

  getSubjectsBySubGradeId(subGradeId: Guid): Observable<Subject[]> {
    return this.http.get<Subject[]>(`${environment.apiUrl}/Subject/GetSubjectsBySubGradeId/${subGradeId}`);
  }

  getSubSubjectsBySubjectId(subjectId: Guid): Observable<SubSubject[]> {
    return this.http.get<SubSubject[]>(`${environment.apiUrl}/Subject/GetSubSubjectsBySubjectId/${subjectId}`);
  }
  // getLevels(): Observable<Level[]> {
  //   return this.http.get<Level[]>(`${environment.apiUrl}/Constant/GetSubscriptionGroup/15?langId=01-01`);
  // }

  getSubscriptionGroup(mId: string, LangId: string): Observable<Constant[]> {
    return this.http.get<Constant[]>(`${environment.apiUrl}/Constant/GetSubscriptionGroup/${mId}?langId=${LangId}`);
  }


  // getCategories(): Observable<Category[]> {
  //   return this.http.get<Category[]>(`${environment.apiUrl}/Constant/GetSubscriptionGroup/14?langId=01-01`);
  // }

  private handelError(errorResponse: HttpErrorResponse) {
    console.error(
      `Backend returned code ${errorResponse.error}, ` +
      `body was: ${errorResponse.error}`);
    return throwError('There is a problem with the service' + errorResponse.status);
  }

  getAllGrades(): Observable<Grade[]> {
    return this.http.get<Grade[]>(`${environment.apiUrl}/Grade`);
  }

  getTeachersByClassSubSubjectId(subSubjectId: Guid, gradeClassId: Guid): Observable<Staff[]> {
    return this.http.get<Staff[]>(`${environment.apiUrl}/Profile/GetTeachersByClassSubSubjectId/${subSubjectId}/${gradeClassId}`);
  }

  getSubSubjectsByClass(Ids: any): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/Subject/GetSubSubjectsByClass`, Ids);
  }

  getSubSubjectsByStudent(Ids: any): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/Subject/GetSubSubjectsByStudent`, Ids);
  }

  getCurriculums(): Observable<Curriculum[]> {
    return this.http.get<Curriculum[]>(`${environment.apiUrl}/Service/Curriculum`);
  }

  getGradesByUserIdAndCurriculumId(curriculumId: Guid): Observable<Grade[]> {
    return this.http.get<Grade[]>(`${environment.apiUrl}/Grade/GetGradesByUserIdAndCurriculumId/${curriculumId}`);
  }

  getGradesByCurriculumId(curriculumId: Guid): Observable<Grade[]> {
    return this.http.get<Grade[]>(`${environment.apiUrl}/Grade/GetGradesByCurriculumId/${curriculumId}`);
  }

  getSubGradesByCurriculumId(curriculumId: Guid): Observable<Grade[]> {
    return this.http.get<Grade[]>(`${environment.apiUrl}/Grade/GetSubGradesByCurriculumId/${curriculumId}`);
  }

  getClasses(examId: Guid, isPublicExamAssign: boolean): Observable<ExamClasses[]> {
    return this.http.get<ExamClasses[]>(`${environment.apiUrl}/AssignExam/GetClasses/${examId}/${isPublicExamAssign}`);
  }

  getServerDateTime(): Observable<Date> {
    return this.http.get<Date>(`${environment.apiUrl}/PrivateExam/GetServerDateTime`);
  }

  getSubscriptionLogo(ServiceId: Guid): Observable<Subscription> {
    return this.http.get<Subscription>(`${environment.apiUrl}/Profile/GetSubscriptionLogo/${localStorage.currentUserSubscription}`);
  }

  getStudentRelationByProfileId(profileId: Guid): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/Profile/GetStudentRelationByProfileId/${profileId}`);
  }
  getServices(): Observable<Service[]> {
    return this.http.get<Service[]>(`${environment.apiUrl}/Service`);
  }

  getServicesByMainCurriculumId(
    mainCurriculumId: Guid,
    pageNo: number = 1,
    pageSize: number = 10000
  ): Observable<Service[]> {
    const params = new HttpParams()
      .set('pageNo', String(pageNo))
      .set('pageSize', String(pageSize))
      .set('mainCurriculumId', mainCurriculumId.toString());
    return this.http.get<Service[]>(
      `${environment.apiUrl}/Service/GetAllByMainCurriculumId`,
      { params }
    );
  }

  getServicesBySubscriptionId(): Observable<SubscriptionService[]> {
    return this.http.get<SubscriptionService[]>(`${environment.apiUrl}/Service/BySubscription/${localStorage.currentUserSubscription}`);
  }

  getServicesBySubscriptionIdPaged(
    subscriptionId: Guid,
    pageNo: number,
    pageSize: number,
    searchText?: string,
    serviceGroupId?: Guid | string | null
  ): Observable<PagedResult<SubscriptionService>> {

    const s = encodeURIComponent(searchText ?? '');
    let url = `${environment.apiUrl}/Service/GetServicesBySubscriptionIdPaged/${subscriptionId}?pageNo=${pageNo}&pageSize=${pageSize}&search=${s}`;

    if (serviceGroupId) {
      url += `&serviceGroupId=${serviceGroupId}`;
    }

    return this.http.get<PagedResult<SubscriptionService>>(url);
  }

  getServicesGroups(): Observable<UserRole[]> {
    return this.http.get<UserRole[]>(`${environment.apiUrl}/Service/GetServicesGroups`);
  }

  getServicesGroupsTree(): Observable<RoleGroupNode[]> {
    return this.http.get<RoleGroupNode[]>(`${environment.apiUrl}/Service/GetServicesGroupsTree`);
  }

  getServicesGroupsTreeByRole(roleId: Guid): Observable<RoleGroupNode[]> {
    return this.http.get<RoleGroupNode[]>(`${environment.apiUrl}/Service/GetServicesGroupsTreeByRole/${roleId}`);
  }

  getServicesForAdminPaged(
    currentUserRoleId: Guid,
    serviceGroupId: Guid,
    pageNo: number,
    pageSize: number,
    searchText?: string
  ): Observable<PagedResult<Service>> {
    const s = encodeURIComponent(searchText ?? '');
    let url = `${environment.apiUrl}/Service/GetServicesForAdminPaged/${currentUserRoleId}/${serviceGroupId}?pageNo=${pageNo}&pageSize=${pageSize}&search=${s}`;
    return this.http.get<PagedResult<Service>>(url);
  }

  getServicesForRootPaged(
    subscriptionId: Guid,
    serviceGroupId: Guid,
    pageNo: number,
    pageSize: number,
    searchText?: string
  ): Observable<PagedResult<Service>> {
    const s = encodeURIComponent(searchText ?? '');
    let url = `${environment.apiUrl}/Service/GetServicesForRootPaged/${subscriptionId}/${serviceGroupId}?pageNo=${pageNo}&pageSize=${pageSize}&search=${s}`;
    return this.http.get<PagedResult<Service>>(url);
  }

  getUserServices(): Observable<Service[]> {
    return this.http.get<Service[]>(`${environment.apiUrl}/Service/GetUserServices`);
  }

  getAllCurriculumsByServiceId(ServiceId: Guid): Observable<Curriculum[]> {
    return this.http.get<Curriculum[]>(`${environment.apiUrl}/Service/GetAllCurriculumsByServiceId/${ServiceId}`);
  }

  getMainCurriculums(): Observable<MainCurriculum[]> {
    return this.http.get<MainCurriculum[]>(`${environment.apiUrl}/MainCurriculum`);
  }

  getMainGradesByAcademicYear(academicYearId: Guid): Observable<AcademicYearGrade[]> {
    return this.http.get<AcademicYearGrade[]>(`${environment.apiUrl}/MainGrade/GetMainGradesByAcademicYear/${academicYearId}`);
  }

  getAllByCurriculumAndServiceId(curriculumId: Guid, serviceId: Guid): Observable<Grade[]> {
    return this.http.get<Grade[]>(`${environment.apiUrl}/Grade/GetAllByCurriculumAndServiceId/${curriculumId}/${serviceId}`);
  }

  getMainSubjects(MainCurriculumId: Guid): Observable<MainSubject[]> {
    return this.http.get<MainSubject[]>(`${environment.apiUrl}/MainSubject/GetAllByCurriculumId/${MainCurriculumId}`);
  }

  getSelectedSubjectsByGradeId(gradeId: Guid): Observable<GradeSubject[]> {
    return this.http.get<GradeSubject[]>(`${environment.apiUrl}/Subject/GetSelectedSubjectsByGradeId/${gradeId}`);
  }

  getClassesBySubGradeId(subGradeId: Guid): Observable<Class[]> {
    return this.http.get<Class[]>(`${environment.apiUrl}/Class/GetClassesBySubGradeId/${subGradeId}`);
  }

  getClassesBySubSubjectIdAndTeacherId(subSubjectId: Guid, teacherId: Guid): Observable<Class[]> {
    return this.http.get<Class[]>(`${environment.apiUrl}/Class/GetClassesBySubSubjectIdAndTeacherId/${subSubjectId}/${teacherId}`);
  }

  getAddedSubjectsByGradeId(gradeId: Guid): Observable<GradeSubject[]> {
    return this.http.get<GradeSubject[]>(`${environment.apiUrl}/Subject/GetAddedSubjectsByGradeId/${gradeId}`);
  }

  // getAddedSubjectsBySubGradeId(subGradeId: Guid): Observable<GradeSubject[]> {
  //   return this.http.get<GradeSubject[]>(`${environment.apiUrl}/Subject/GetAddedSubjectsBySubGradeId/${subGradeId}`);
  // }

  getAddedSubSubjectsBySubjectId(subjectId: Guid): Observable<GradeSubject[]> {
    return this.http.get<GradeSubject[]>(`${environment.apiUrl}/Subject/GetAddedSubSubjectsBySubjectId/${subjectId}`);
  }

  getAllAcademicYears(serviceId: Guid, curriculumId: Guid): Observable<AcademicYear[]> {
    return this.http.get<AcademicYear[]>(`${environment.apiUrl}/AcadimicYear/GetAllAcademicYears/${serviceId}/${curriculumId}`);
  }

  addNewCurriculum(curriculum: Curriculum): Observable<Curriculum> {
    return this.http.post<Curriculum>(`${environment.apiUrl}/Service/AddNewCurriculum`, curriculum);
  }

  updateCurriculum(curriculum: Curriculum): Observable<Curriculum> {
    return this.http.put<Curriculum>(`${environment.apiUrl}/Service/Curriculum/${curriculum.id}`, curriculum);
  }

  addNewService(service: Service): Observable<Service> {
    return this.http.post<Service>(`${environment.apiUrl}/Service`, service);
  }

  updateService(service: Service): Observable<Service> {
    return this.http.put<Service>(`${environment.apiUrl}/Service/${service.id}`, service);
  }

  addNewAcademicYear(academicYear: AcademicYear): Observable<string> {
    return this.http.post(`${environment.apiUrl}/AcadimicYear`, academicYear, { 
      responseType: 'text'
    });
  }
  
  updateAcademicYear(academicYear: AcademicYear): Observable<string> {
    return this.http.put(`${environment.apiUrl}/AcadimicYear/${academicYear.id}`, academicYear, { 
      responseType: 'text'
    });
  }

  deleteAcademicYear(id: string): Observable<string> {
    return this.http.delete(`${environment.apiUrl}/AcadimicYear/${id}`, {
      responseType: 'text' 
    });
  }

  getStudentsBySubGradeId(subGradeId: Guid, pageNo: number, pageSize: number): Observable<PagedGradeStudent> {
    return this.http.get<PagedGradeStudent>(`${environment.apiUrl}/Profile/GetStudentsBySubGradeId/${subGradeId}?pageNo=${pageNo}&pageSize=${pageSize}`);
  }

  getStudentsByClassId(classId: Guid): Observable<Student[]> {
    return this.http.get<Student[]>(`${environment.apiUrl}/Profile/GetStudentsByClassId/${classId}`);
  }

  getParentsByClassId(classId: Guid): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/Profile/GetParentsByClassId/${classId}`);
  }

  addStudentProfileToSubGrade(subGradeId: Guid, student: Student): Observable<Student> {
    return this.http.post<Student>(`${environment.apiUrl}/Profile/AddStudentProfileToSubGrade/${subGradeId}`, student);
  }

  addStudentProfileToClass(subGradeId: Guid, classId: Guid, student: Student): Observable<Student> {
    return this.http.post<Student>(`${environment.apiUrl}/Profile/AddStudentProfileToClass/${subGradeId}/${classId}`, student);
  }

  getProfileById(profileId: Guid): Observable<Student[]> {
    return this.http.get<Student[]>(`${environment.apiUrl}/Profile/${profileId}`);
  }

  updateProfile(profile: Profile): Observable<Student> {
    return this.http.put<Student>(`${environment.apiUrl}/Profile/${profile.id}`, profile);
  }

  deleteStudentProfile(studentId: Guid): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/Profile/${studentId}`);
  }

  changeStudentSubGrade(studentId: Guid, subGradeId: Guid): Observable<Student> {
    return this.http.put<Student>(`${environment.apiUrl}/Profile/ChangeStudentSubGrade/${studentId}/${subGradeId}`, {});
  }

  addGradesToCurriculum(selectedGrades): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/Grade/AddGradesToCurriculum`, selectedGrades);
  }

  addSubjectToGrade(addedSubject, subGradeId: Guid): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/Subject/AddSubjectToGrade/${subGradeId}`, addedSubject);
  }

  addSubjectToGrades(addedSubjects): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/Subject/AddSubjectToGrades`, addedSubjects);
  }

  getSemestersByAcademicYearId(academicYearId: Guid): Observable<Semester[]> {
    return this.http.get<Semester[]>(`${environment.apiUrl}/Semester/GetSemestersByAcademicYearId/${academicYearId}`);
  }

  getSemestersByServiceId(serviceId: Guid): Observable<Semester[]> {
    return this.http.get<Semester[]>(`${environment.apiUrl}/Semester/GetSemestersByServiceId/${serviceId}`);
  }

  getSemestersByAcademicYear(academicYearId: Guid): Observable<Semester[]> {
    return this.http.get<Semester[]>(`${environment.apiUrl}/Semester/GetAllByAcademicYear/${academicYearId}`);
  }

  addNewSemester(semester: any): Observable<string> {
    return this.http.post(`${environment.apiUrl}/Semester`, semester, {
      responseType: 'text'
    });
  }
  
  updateSemester(semester: any, id: any): Observable<string> {
    return this.http.put(`${environment.apiUrl}/Semester/${id}`, semester, {
      responseType: 'text'
    });
  }

  activateSemester(semesterId: Guid, academicYearId: Guid): Observable<Semester> {
    return this.http.put<Semester>(`${environment.apiUrl}/Semester/ActivateSemester/${semesterId}/${academicYearId}`, {});
  }

  getGradesByAcademicYearId(academicYearId: Guid): Observable<AcademicYearGrade[]> {
    return this.http.get<AcademicYearGrade[]>(`${environment.apiUrl}/Grade/GetGradesByAcademicYearId/${academicYearId}`);
  }

  getClassesBySubGradeIdAndSemesterId(subGradeId: Guid, semesterId: Guid): Observable<Class[]> {
    return this.http.get<Class[]>(`${environment.apiUrl}/Class/GetClassesBySubGradeIdAndSemesterId/${subGradeId}/${semesterId}`);
  }

  getAllClassesBySubGradeIdAndSemesterId(subGradeId: Guid, semesterId: Guid): Observable<Class[]> {
    return this.http.get<Class[]>(`${environment.apiUrl}/Class/GetAllClassesBySubGradeIdAndSemesterId/${subGradeId}/${semesterId}`);
  }

  updateClaasesInformation(classes): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/Class/UpdateClaasesInformation`, classes);
  }

  generateClasses(gradeId: Guid, semesterId: Guid, numberOfClasses: number): Observable<Class[]> {
    return this.http.post<Class[]>(`${environment.apiUrl}/Class/GenerateClasses/${gradeId}/${semesterId}/${numberOfClasses}`, {});
  }

  addNewClass(gradeClass: Class): Observable<Class> {
    return this.http.post<Class>(`${environment.apiUrl}/Class`, gradeClass);
  }

  deleteClass(classId: Guid): Observable<any> {
    return this.http.delete<any>(`${environment.apiUrl}/Class/${classId}`);
  }

  updateNumberOfClasses(numberOfClasses: number, subGradeId: Guid): Observable<Class> {
    return this.http.put<Class>(`${environment.apiUrl}/Grade/UpdateNumberOfClasses/${numberOfClasses}/${subGradeId}`, {});
  }

  getUnassignedStudentsToClassBySubGradeId(serviceId: Guid, gradeId: Guid): Observable<Student[]> {
    return this.http.get<Student[]>(`${environment.apiUrl}/Profile/GetUnassignedStudentsToClassBySubGradeId/${serviceId}/${gradeId}`);
  }

  getAssignedStudentsToClassByClassId(classId: Guid): Observable<Student[]> {
    return this.http.get<Student[]>(`${environment.apiUrl}/Profile/GetAssignedStudentsToClassByClassId/${classId}`);
  }

  assignStudentToClass(studentId: Guid, classId: Guid): Observable<Student[]> {
    return this.http.post<Student[]>(`${environment.apiUrl}/Profile/AssignStudentToClass/${studentId}/${classId}`, {});
  }

  removeStudentFromClass(studentId: Guid, classId: Guid): Observable<any[]> {
    return this.http.delete<any[]>(`${environment.apiUrl}/Profile/RemoveStudentFromClass/${studentId}/${classId}`, {});
  }

  getStaffBySubscriptionId(pageNo: number, pageSize: number): Observable<PagedStaff> {
    return this.http.get<PagedStaff>(`${environment.apiUrl}/Profile/GetStaffBySubscriptionId/${localStorage.currentUserSubscription}?pageNo=${pageNo}&pageSize=${pageSize}`);
  }

  getStaffBySubscriptionIdAndFilters(
    pageNo: number,
    pageSize: number,
    serviceId?: Guid | null,
    curriculumId?: Guid | null,
    academicYearId?: Guid | null,
    gradeId?: Guid | null,
    subGradeId?: Guid | null,
    subjectId?: Guid | null,
    subSubjectId?: Guid | null,
    teacherName?: string | null
  ): Observable<PagedStaff> {
    let params = new HttpParams()
      .set('pageNo', pageNo.toString())
      .set('pageSize', pageSize.toString());

    if (serviceId) {
      params = params.set('selectedServiceId', String(serviceId));
    }
    if (curriculumId) {
      params = params.set('curriculumId', String(curriculumId));
    }
    if (academicYearId) {
      params = params.set('academicYearId', String(academicYearId));
    }
    if (gradeId) {
      params = params.set('gradeId', String(gradeId));
    }
    if (subGradeId) {
      params = params.set('subGradeId', String(subGradeId));
    }
    if (subjectId) {
      params = params.set('subjectId', String(subjectId));
    }
    if (subSubjectId) {
      params = params.set('subSubjectId', String(subSubjectId));
    }
    if (teacherName && teacherName.trim()) {
      params = params.set('teacherName', teacherName.trim());
    }

    // serviceId is optional: backend can treat missing serviceId as "all services"
    return this.http.get<PagedStaff>(
      `${environment.apiUrl}/Profile/GetStaffBySubscriptionIdAndFilters/${localStorage.currentUserSubscription}`,
      { params }
    );
  }

  createStaffProfile(staff: Staff): Observable<boolean> {
    return this.http.post<boolean>(`${environment.apiUrl}/Profile/AddStaffProfile`, staff);
  }

  updateStaffProfile(Staff: Staff): Observable<any> {
    return this.http.put<any>(`${environment.apiUrl}/Profile/UpdateStaffProfile/${Staff.id}`, Staff);
  }

  getStaffProfileById(staffId: Guid): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/Profile/GetStaffProfileById/${staffId}`);
  }

  updateSatffProfile(staff: Staff): Observable<Staff> {
    return this.http.put<Staff>(`${environment.apiUrl}/Profile/${staff.id}`, staff);
  }

  deleteProfile(staffId: Guid): Observable<any[]> {
    return this.http.delete<any[]>(`${environment.apiUrl}/Profile/${staffId}`, {});
  }

  deactivateProfile(userId: Guid): Observable<Staff> {
    return this.http.put<Staff>(`${environment.apiUrl}/Profile/DeactivateProfile/${userId}`, {});
  }

  activateProfile(userId: Guid): Observable<Staff> {
    return this.http.put<Staff>(`${environment.apiUrl}/Profile/ActivateProfile/${userId}`, {});
  }

  // getSubjectsBycurriculumIdAndGradeId(curriculumId: Guid, gradeId: Guid): Observable<Subject[]> {
  //   return this.http.get<Subject[]>(`${environment.apiUrl}/Subject/GetSubjectsBycurriculumIdAndGradeId/${curriculumId}/${gradeId}`);
  // }

  getClassesSubjectsBySubGradeId(subGradeId: Guid, semesterId: Guid, serviceId: Guid): Observable<ClassesSubSubjects[]> {
    return this.http.get<ClassesSubSubjects[]>(`${environment.apiUrl}/Class/GetClassesSubjectsBySubGradeId/${subGradeId}/${semesterId}/${serviceId}`);
  }

  getAllClassesSubjectsBySubGradeId(subGradeId: Guid, semesterId: Guid, serviceId: Guid): Observable<ClassesSubSubjects[]> {
    return this.http.get<ClassesSubSubjects[]>(`${environment.apiUrl}/Class/GetAllClassesSubjectsBySubGradeId/${subGradeId}/${semesterId}/${serviceId}`);
  }

  getClassesSubjectsBySubSubjectId(subSubjectId: Guid): Observable<ClassSubSubject[]> {
    return this.http.get<ClassSubSubject[]>(`${environment.apiUrl}/Class/GetClassesSubjectsBySubSubjectId/${subSubjectId}`);
  }

  getAllActiveStaffBySubscription(serviceId: Guid): Observable<Staff[]> {
    return this.http.get<Staff[]>(`${environment.apiUrl}/Profile/GetAllActiveStaffBySubscription/${localStorage.currentUserSubscription}/${serviceId}`);
  }

  getActiveTeachersByServiceId(serviceId: Guid): Observable<Staff[]> {
    return this.http.get<Staff[]>(`${environment.apiUrl}/Profile/GetActiveTeachersByServiceId/${serviceId}`);
  }

  createTeachingRelation(classId: Guid, subSubjectId: Guid, teacherUserId: Guid): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/Profile/CreateTeachingRelation/${classId}/${subSubjectId}/${teacherUserId}`, {});
  }

  updateTeachingRelation(classId: Guid, subjectId: Guid, staffId: Guid): Observable<Staff> {
    return this.http.put<Staff>(`${environment.apiUrl}/Profile/UpdateTeachingRelation/${classId}/${subjectId}/${staffId}`, {});
  }

  deleteTeachingRelation(relationId: Guid): Observable<any> {
    return this.http.delete<any>(`${environment.apiUrl}/Profile/DeleteTeachingRelation/${relationId}`);
  }

  getSupervisorsByAcademicYear(serviceId: Guid, academicYearId: Guid): Observable<Staff[]> {
    return this.http.get<Staff[]>(`${environment.apiUrl}/Profile/GetSupervisorsByAcademicYear/${serviceId}/${academicYearId}`);
  }

  getManagersByAcademicYear(serviceId: Guid, academicYearId: Guid): Observable<Staff[]> {
    return this.http.get<Staff[]>(`${environment.apiUrl}/Profile/GetManagersByAcademicYear/${serviceId}/${academicYearId}`);
  }

  getSupervisorRelations(serviceId: Guid, supervisorId: Guid): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/Profile/GetSupervisorRelations/${serviceId}/${supervisorId}`);
  }

  getManagerRelations(serviceId: Guid, managerId: Guid): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/Profile/GetManagerRelations/${serviceId}/${managerId}`);
  }
  deleteSupervisorRelation(relationId: Guid, supervisorId: Guid, serviceId: Guid): Observable<any[]> {
    return this.http.delete<any[]>(`${environment.apiUrl}/Profile/DeleteSupervisorRelation/${relationId}/${supervisorId}/${serviceId}`, {});
  }

  deleteManagerRelation(relationId: Guid, managerId: Guid, serviceId: Guid): Observable<any[]> {
    return this.http.delete<any[]>(`${environment.apiUrl}/Profile/DeleteManagerRelation/${relationId}/${managerId}/${serviceId}`, {});
  }

  createSupervisorRelation(relations: any): Observable<boolean> {
    return this.http.post<boolean>(`${environment.apiUrl}/Profile/CreateSupervisorRelation`, relations);
  }

  createManagerRelation(relations: any): Observable<boolean> {
    return this.http.post<boolean>(`${environment.apiUrl}/Profile/CreateManagerRelation`, relations);
  }

  changePassword(changePassword: any): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/Account/ChangePassword`, changePassword);
  }

  resetUserPassword(email: string): Observable<boolean> {
    return this.http.post<boolean>(`${environment.apiUrl}/Account/ResetUserPassword/${email}`, {});
  }

  getExamsByServiceId(serviceId: Guid): Observable<Exam[]> {
    return this.http.get<Exam[]>(`${environment.apiUrl}/PrivateExam/GetExamsByServiceId/${serviceId}`);
  }

  getReportsSetup(): Observable<Report[]> {
    return this.http.get<Report[]>(`${environment.apiUrl}/Report`);
  }

  saveReportSetup(report: Report): Observable<Report> {
    return this.http.post<Report>(`${environment.apiUrl}/Report`, report);
  }

  updateReportSetup(report: Report): Observable<Report> {
    return this.http.put<Report>(`${environment.apiUrl}/Report/${report.id}`, report);
  }

  getReportSetupByIndexTreeNodeId(reportId: Guid): Observable<Report> {
    return this.http.get<Report>(`${environment.apiUrl}/Report/GetReportSetupByIndexTreeNodeId/${reportId}`);
  }

  getReportFiltersByReportId(reportId: Guid): Observable<ReportFilter[]> {
    return this.http.get<ReportFilter[]>(`${environment.apiUrl}/Report/GetReportFiltersByReportId/${reportId}`);
  }

  saveReportFilter(reportFilter: ReportFilter): Observable<ReportFilter> {
    return this.http.post<ReportFilter>(`${environment.apiUrl}/Report/AddReportFilter`, reportFilter);
  }

  updateReportFilter(reportFilter: ReportFilter): Observable<ReportFilter> {
    return this.http.put<ReportFilter>(`${environment.apiUrl}/Report/UpdateReportFilter/${reportFilter.id}`, reportFilter);
  }

  deleteReportFilter(reportId: Guid): Observable<ReportFilter> {
    return this.http.delete<ReportFilter>(`${environment.apiUrl}/Report/DeleteReportFilter/${reportId}`, {});
  }

  getSubjectsByCurriculumId(curriculumId: Guid): Observable<Subject[]> {
    return this.http.get<Subject[]>(`${environment.apiUrl}/Subject/GetSubjectsByCurriculumId/${curriculumId}`);
  }

  addCourse(course: Course): Observable<Course> {
    return this.http.post<Course>(`${environment.apiUrl}/Course/AddCourse`, course);
  }

  getCoursesBySemesterId(semesterId: Guid): Observable<Course[]> {
    return this.http.get<Course[]>(`${environment.apiUrl}/Course/GetCoursesBySemesterId/${semesterId}`);
  }

  getCourseById(courseId: Guid): Observable<Course> {
    return this.http.get<Course>(`${environment.apiUrl}/Course/GetCourseById/${courseId}`);
  }

  updateCourse(course: Course): Observable<Course> {
    return this.http.put<Course>(`${environment.apiUrl}/Course/UpdateCourse/${course.id}`, course);
  }

  deleteCourse(courseId: Guid): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/Course/${courseId}`);
  }

  getStudentsByServiceId(serviceId: Guid): Observable<Student[]> {
    return this.http.get<Student[]>(`${environment.apiUrl}/Profile/GetStudentsByServiceId/${serviceId}`);
  }

  addStudentToCourse(studentId: Guid, courseId: Guid): Observable<Student[]> {
    return this.http.post<Student[]>(`${environment.apiUrl}/Course/AddStudentToCourse/${studentId}/${courseId}`, {});
  }

  getUnassignedStudentsToCourseByServiceId(serviceId: Guid, courseId: Guid): Observable<Student[]> {
    return this.http.get<Student[]>(`${environment.apiUrl}/Course/GetUnassignedStudentsToCourseByServiceId/${serviceId}/${courseId}`);
  }

  getAssignedStudentsToCourse(courseId: Guid): Observable<Student[]> {
    return this.http.get<Student[]>(`${environment.apiUrl}/Course/GetAssignedStudentsToCourse/${courseId}`);
  }

  removeStudentFromCourse(studentId: Guid, courseId: Guid): Observable<any> {
    return this.http.delete<any>(`${environment.apiUrl}/Course/RemoveStudentFromCourse/${studentId}/${courseId}`, {});
  }

  deleteSubject(subjectId: Guid): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/Subject/${subjectId}`);
  }

  updateSubject(subject: Subject, subjectId: Guid): Observable<Subject> {
    subject.id = subjectId;
    return this.http.put<Subject>(`${environment.apiUrl}/Subject/${subjectId}`, subject);
  }

  updateGrade(grade: Grade, gradeId: Guid): Observable<Grade> {
    grade.id = gradeId;
    return this.http.put<Grade>(`${environment.apiUrl}/Grade/${gradeId}`, grade);
  }

  deleteGrade(gradeId: Guid): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/Grade/${gradeId}`);
  }

  getSubjectPrerequisitesBySubjectId(subjectId: Guid): Observable<SubjectPrerequisite[]> {
    return this.http.get<SubjectPrerequisite[]>(`${environment.apiUrl}/Subject/GetSubjectPrerequisitesBySubjectId/${subjectId}`);
  }

  addSubjectPrerequisite(subjectPrerequisite: SubjectPrerequisite): Observable<SubjectPrerequisite> {
    return this.http.post<SubjectPrerequisite>(`${environment.apiUrl}/Subject/AddSubjectPrerequisite`, subjectPrerequisite);
  }

  updateSubjectPrerequisite(subjectPrerequisite: SubjectPrerequisite): Observable<any> {
    return this.http.put<any>(`${environment.apiUrl}/Subject/UpdateSubjectPrerequisite/${subjectPrerequisite.id}`, subjectPrerequisite);
  }

  deleteSubjectPrerequisite(subjectId: Guid): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/Subject/DeleteSubjectPrerequisite/${subjectId}`);
  }

  addGrade(grade: Grade): Observable<Grade> {
    return this.http.post<Grade>(`${environment.apiUrl}/Grade`, grade);
  }

  addSubGrade(subGrade: SubGrade): Observable<SubGrade> {
    return this.http.post<SubGrade>(`${environment.apiUrl}/Grade/AddSubGrade`, subGrade);
  }

  updateSubGrade(subGrade: SubGrade): Observable<any> {
    return this.http.put<any>(`${environment.apiUrl}/Grade/UpdateSubGrade/${subGrade.id}`, subGrade);
  }

  deleteSubGrade(subGradeId: Guid): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/Grade/DeleteSubGrade/${subGradeId}`);
  }

  addSubSubject(subSubject: SubSubject): Observable<SubSubject> {
    return this.http.post<SubSubject>(`${environment.apiUrl}/Subject/AddSubSubject`, subSubject);
  }

  updateSubSubject(subSubject: SubSubject): Observable<any> {
    return this.http.put<any>(`${environment.apiUrl}/Subject/UpdateSubSubject/${subSubject.id}`, subSubject);
  }

  deleteSubSubject(subGradeId: Guid): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/Subject/DeleteSubSubject/${subGradeId}`);
  }

  getCoursesBySubjectId(subjectId: Guid): Observable<ExamCourses[]> {
    return this.http.get<ExamCourses[]>(`${environment.apiUrl}/Course/GetCoursesBySubjectId/${subjectId}`);
  }

  getCourseStudentsBySubjectId(subjectId: Guid): Observable<ExamAssignStudents[]> {
    return this.http.get<ExamAssignStudents[]>(`${environment.apiUrl}/Course/GetCourseStudentsBySubjectId/${subjectId}`);
  }

  getGradesBySubjectTeacher(): Observable<Grade[]> {
    return this.http.get<Grade[]>(`${environment.apiUrl}/Grade/GetGradesBySubjectTeacher`);
  }

  getStudentsBySubscriptionId(pageNo: number, pageSize: number): Observable<PagedStudent> {
    return this.http.get<PagedStudent>(`${environment.apiUrl}/Profile/GetStudentsBySubscriptionId/${localStorage.currentUserSubscription}?pageNo=${pageNo}&pageSize=${pageSize}`);
  }

  getStudentsBySubscriptionIdAndFilters(
    pageNo: number,
    pageSize: number,
    serviceId?: Guid | null,
    curriculumId?: Guid | null,
    academicYearId?: Guid | null,
    semesterId?: Guid | null,
    gradeId?: Guid | null,
    subGradeId?: Guid | null,
    subjectId?: Guid | null,
    subSubjectId?: Guid | null,
    studentName?: string | null,
    classId?: Guid | null
  ): Observable<PagedStudent> {
    let params = new HttpParams()
      .set('pageNo', pageNo.toString())
      .set('pageSize', pageSize.toString());

    if (serviceId) {
      params = params.set('selectedServiceId', String(serviceId));
    }
    if (curriculumId) {
      params = params.set('curriculumId', String(curriculumId));
    }
    if (academicYearId) {
      params = params.set('academicYearId', String(academicYearId));
    }
    if (semesterId) {
      params = params.set('semesterId', String(semesterId));
    }
    if (gradeId) {
      params = params.set('gradeId', String(gradeId));
    }
    if (subGradeId) {
      params = params.set('subGradeId', String(subGradeId));
    }
    if (subjectId) {
      params = params.set('subjectId', String(subjectId));
    }
    if (subSubjectId) {
      params = params.set('subSubjectId', String(subSubjectId));
    }
    if (classId) {
      params = params.set('classId', String(classId));
    }
    if (studentName && studentName.trim()) {
      params = params.set('studentName', studentName.trim());
    }

    return this.http.get<PagedStudent>(
      `${environment.apiUrl}/Profile/GetStudentsBySubscriptionIdAndFilters/${localStorage.currentUserSubscription}`,
      { params }
    );
  }

  getParentsBySubscriptionId(pageNo: number, pageSize: number): Observable<PagedParent> {
    return this.http.get<PagedParent>(`${environment.apiUrl}/Profile/GetParentsBySubscriptionId/${localStorage.currentUserSubscription}?pageNo=${pageNo}&pageSize=${pageSize}`);
  }

  getParentsBySubscriptionIdAndFilters(
    pageNo: number,
    pageSize: number,
    serviceId?: Guid | null,
    curriculumId?: Guid | null,
    academicYearId?: Guid | null,
    gradeId?: Guid | null,
    subGradeId?: Guid | null,
    parentName?: string | null
  ): Observable<PagedParent> {
    let params = new HttpParams()
      .set('pageNo', pageNo.toString())
      .set('pageSize', pageSize.toString());

    if (serviceId) {
      params = params.set('selectedServiceId', String(serviceId));
    }
    if (curriculumId) {
      params = params.set('curriculumId', String(curriculumId));
    }
    if (academicYearId) {
      params = params.set('academicYearId', String(academicYearId));
    }
    if (gradeId) {
      params = params.set('gradeId', String(gradeId));
    }
    if (subGradeId) {
      params = params.set('subGradeId', String(subGradeId));
    }
    if (parentName && parentName.trim()) {
      params = params.set('parentName', parentName.trim());
    }

    return this.http.get<PagedParent>(
      `${environment.apiUrl}/Profile/GetParentsBySubscriptionIdAndFilters/${localStorage.currentUserSubscription}`,
      { params }
    );
  }

  getStudentProfileById(studentId: Guid): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/Profile/GetStudentProfileById/${studentId}`);
  }

  updateStudentProfile(student: Student): Observable<any> {
    return this.http.put<any>(`${environment.apiUrl}/Profile/UpdateStudentProfile/${student.id}`, student);
  }

  getParentProfileById(parentId: Guid): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/Profile/GetParentProfileById/${parentId}`);
  }

  addParentProfile(parent: Parent): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/Profile/AddParentProfile`, parent);
  }

  updateParentProfile(parent: Parent): Observable<any> {
    return this.http.put<any>(`${environment.apiUrl}/Profile/UpdateParentProfile/${parent.id}`, parent);
  }

  getSubSubjectsBySubGradeId(subGradeId: Guid): Observable<SubSubject[]> {
    return this.http.get<SubSubject[]>(`${environment.apiUrl}/Subject/GetSubSubjectsBySubGradeId/${subGradeId}`);
  }

  getClassByClassSubSubjectId(classSubSubjectId: Guid): Observable<Class> {
    return this.http.get<Class>(`${environment.apiUrl}/Class/GetClassByClassSubSubjectId/${classSubSubjectId}`);
  }

  getStaffRelationsByStaffId(staffId: Guid): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/Profile/GetStaffRelationsByStaffId/${staffId}`);
  }

  getTeachingRelations(): Observable<TeacherRelation[]> {
    return this.http.get<TeacherRelation[]>(`${environment.apiUrl}/Profile/GetTeachingRelations`);
  }

  getSupervisingRelations(): Observable<TeacherRelation[]> {
    return this.http.get<TeacherRelation[]>(`${environment.apiUrl}/Profile/GetSupervisingRelations`);
  }

  getManagingRelations(): Observable<TeacherRelation[]> {
    return this.http.get<TeacherRelation[]>(`${environment.apiUrl}/Profile/GetManagingRelations`);
  }

  getTeachersByFilters(pageNo: number, pageSize: number, filter: Filters): Observable<PagedStaff> {
    let httpParams = new HttpParams();
    Object.keys(filter).forEach(function (key) {
      httpParams = httpParams.append(key, filter[key]);
    });
    return this.http.get<PagedStaff>(`${environment.apiUrl}/Profile/GetTeachersByFilters?pageNo=${pageNo}&pageSize=${pageSize}&${httpParams.toString()}`);
  }

  getSupervisorsByFilters(pageNo: number, pageSize: number, filter: Filters): Observable<PagedStaff> {
    let httpParams = new HttpParams();
    Object.keys(filter).forEach(function (key) {
      httpParams = httpParams.append(key, filter[key]);
    });
    return this.http.get<PagedStaff>(`${environment.apiUrl}/Profile/GetSupervisorsByFilters?pageNo=${pageNo}&pageSize=${pageSize}&${httpParams.toString()}`);
  }

  getManagersByFiltersAsync(pageNo: number, pageSize: number, filter: Filters): Observable<PagedStaff> {
    let httpParams = new HttpParams();
    Object.keys(filter).forEach(function (key) {
      httpParams = httpParams.append(key, filter[key]);
    });
    return this.http.get<PagedStaff>(`${environment.apiUrl}/Profile/GetManagersByFiltersAsync?pageNo=${pageNo}&pageSize=${pageSize}&${httpParams.toString()}`);
  }

  getTeachingRelationsClassLevel(): Observable<TeacherRelation[]> {
    return this.http.get<TeacherRelation[]>(`${environment.apiUrl}/Profile/GetTeachingRelationsClassLevel`);
  }

  getTeachingRelationsClassLevelWithoutSubject(): Observable<TeacherRelation[]> {
    return this.http.get<TeacherRelation[]>(`${environment.apiUrl}/Profile/GetTeachingRelationsClassLevelWithoutSubject`);
  }

  getTeachingRelationsGradeLevel(): Observable<TeacherRelation[]> {
    return this.http.get<TeacherRelation[]>(`${environment.apiUrl}/Profile/GetTeachingRelationsGradeLevel`);
  }

  getSupervisorRelationsClassLevel(): Observable<TeacherRelation[]> {
    return this.http.get<TeacherRelation[]>(`${environment.apiUrl}/Profile/GetSupervisorRelationsClassLevel`);
  }

  getSupervisorRelationsClassLevelWithoutSubject(): Observable<TeacherRelation[]> {
    return this.http.get<TeacherRelation[]>(`${environment.apiUrl}/Profile/GetSupervisorRelationsClassLevelWithoutSubject`);
  }

  getManagerRelationsClassLevel(): Observable<TeacherRelation[]> {
    return this.http.get<TeacherRelation[]>(`${environment.apiUrl}/Profile/GetManagerRelationsClassLevel`);
  }

  getManagerRelationsClassLevelWithoutSubject(): Observable<TeacherRelation[]> {
    return this.http.get<TeacherRelation[]>(`${environment.apiUrl}/Profile/GetManagerRelationsClassLevelWithoutSubject`);
  }

  getProfilesPhotosMembersFilters(profileType: ProfileType): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/Profile/GetProfilesPhotosMembersFilters/${profileType}`);
  }

  getStudents(pageNo: number, pageSize: number, classId: Guid): Observable<PagedStudent> {
    return this.http.get<PagedStudent>(`${environment.apiUrl}/Profile/GetStudents/${classId}?pageNo=${pageNo}&pageSize=${pageSize}`);
  }

  updateProfilePhoto(ProfileId: Guid, personPicId: Guid): Observable<any> {
    return this.http.post(`${environment.apiUrl}/Profile/UpdateProfilePhoto/${ProfileId}/${personPicId}`, {}, { responseType: 'text' as 'json' });
  }

  getSubjectsByStudentId(studentId: Guid): Observable<Subject[]> {
    return this.http.get<Subject[]>(`${environment.apiUrl}/Subject/GetSubjectsByStudentId/${studentId}`, {});
  }

  getSubSubjectsByStudentId(studentId: Guid): Observable<SubSubject[]> {
    return this.http.get<SubSubject[]>(`${environment.apiUrl}/Subject/GetSubSubjectsByStudentId/${studentId}`, {});
  }

  getCoursesByStudentId(studentId: Guid): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/Course/GetCoursesByStudentId/${studentId}`, {});
  }

  getCoursesByTeacherId(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/Course/GetCoursesByTeacherId`, {});
  }

  linkStudentToParent(parentProfileId: Guid, studentProfileId: Guid): Observable<boolean> {
    return this.http.post<boolean>(
      `${environment.apiUrl}/Profile/LinkStudentToParent/${parentProfileId}/${studentProfileId}`,
      {}
    );
  }

  generateAllClasses(academicYearId: Guid, mode: 'alpha' | 'numeric' | 'words'): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/Class/GenerateAllClasses/${academicYearId}/${mode}`,
      {}
    );
  }

  getUserKindByProfileId(profileId: Guid): Observable<string> {
    return this.http.get(`${environment.apiUrl}/Profile/GetUserKindByProfileId/${profileId}`, { responseType: 'text' });
  }

  searchParentProfiles(query: string): Observable<any> {
    return this.http.get(
      `${environment.apiUrl}/Profile/SearchParents?q=${encodeURIComponent(query)}`
    );
  }

  unlinkStudentFromParent(parentId: Guid, studentId: Guid): Observable<any> {
    return this.http.delete(
      `${environment.apiUrl}/Profile/UnlinkStudentFromParent/${parentId}/${studentId}`
    );
  }

  getStudentProfileWithParentsById(studentId: Guid): Observable<any> {
    return this.http.get(
      `${environment.apiUrl}/Profile/GetStudentProfileWithParentsById/${studentId}`
    );
  }


}
